export default "__VITE_ASSET__12mcHl8i__"